import axios from "axios";
import { API_BASE_URL } from "../config/api";
const CODE_ONLY_UNLOCK_EMAIL = "code-only@farewise.de";

export class UnlockService {
  static async register(code: string): Promise<void> {
    try {
      await axios.post(
        `${API_BASE_URL}/register`,
        { email: CODE_ONLY_UNLOCK_EMAIL, code },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    } catch (error: any) {
      console.error("UnlockService error:", error);
      const msg = error.response?.data?.detail || "An error occurred during unlock.";
      throw new Error(msg);
    }
  }
}
